export const GEMX_TEMPLATE_SETUP_GUIDE_KEY = 'gemx:template-setup-guide:data';
export const GEMX_MULTI_TEMPLATE_SETUP_GUIDE_KEY = 'gemx:multi-template-setup-guide:data';
export const GEMX_PRICE_SETUP_GUIDE_KEY = 'gemx:price-setup-guide:data';
export const GEMX_URL_REDIRECT_SETUP_GUIDE_KEY = 'gemx:url-redirect-setup-guide:data';

export const SETUP_GUIDE_CONFIG = {
  ANIMATION_TIME_IN_MS: 300,
};
